import axios from "axios";

// Le token JWT vit dans un cookie httpOnly posé par le backend (inaccessible en JS,
// donc protégé du vol par XSS) : il est envoyé automatiquement par le navigateur
// via withCredentials, plus besoin de l'attacher manuellement en header.
const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}/api`,
  withCredentials: true,
});

api.interceptors.response.use(
  (response) => response,
  (error) => {

    if (error.response?.status === 401) {
      localStorage.removeItem("isLoggedIn");
      localStorage.removeItem("role");
      localStorage.removeItem("userId");
      localStorage.removeItem("username");
      localStorage.removeItem("fullname");
      localStorage.removeItem("profileImage");
      localStorage.removeItem("emailConfirmed");
      localStorage.removeItem("isVerified");

      // if (window.location.pathname !== "/login") {
      //   window.location.href = "/login";
      // }
    }

    return Promise.reject(error);
  }
);

export default api;